import {FC, FormEvent} from "react";

import {ChevronRightIcon} from "@chakra-ui/icons";
import {Input, Box, IconButton} from "@chakra-ui/react";
import {ReturnValues} from "hooks/useInputs";

interface SearchBarProps extends Omit<ReturnValues, "reset"> {
    handleSubmit: (e: FormEvent) => void;
}

const SearchBar: FC<SearchBarProps> = ({
    inputs,
    handleChange,
    handleSubmit,
}) => {
    return (
        <Box
            as={"form"}
            onSubmit={handleSubmit}
            d={"flex"}
            alignItems={"center"}
            mt={"1.5rem"}
            w={{base: "80vw", md: "40vw"}}
        >
            <Input
                type={"text"}
                name={"domain"}
                onChange={handleChange}
                value={inputs.domain}
                placeholder={"Search for any IP address or domain"}
                bgColor={"#fff"}
                w={"100%"}
                fontSize={{
                    base: "0.8rem",
                    sm: "1rem",
                    md: "0.8rem",
                    lg: "1rem",
                }}
                borderRadius={"12px"}
                borderRightRadius={"none"}
            />
            <IconButton
                icon={<ChevronRightIcon />}
                aria-label={"submit-button"}
                type={"submit"}
                bgColor={"#000"}
                color={"#fff"}
                borderRadius={"12px"}
                borderLeftRadius={"none"}
                h={"100%"}
                _hover={{
                    bgColor: "#000",
                }}
                _active={{
                    bgColor: "none",
                }}
            />
        </Box>
    );
};

export default SearchBar;
